
import React from "react";
import { Brain, Code, Shield, Zap } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import FadeInWhenVisible from "./FadeInWhenVisible";

const BenefitsSection: React.FC = () => {
  return (
    <section className="py-20 bg-white dark:bg-gray-950">
      <div className="container mx-auto px-4">
        <FadeInWhenVisible>
          <div className="text-center mb-16">
            <Badge className="mb-2">Why Choose Our Marketplace</Badge>
            <h2 className="text-3xl md:text-4xl font-bold mb-4 dark:text-white">Unlock the Power of AI Agents</h2>
            <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
              Our marketplace offers a wide range of benefits for both users and creators
            </p>
          </div>
        </FadeInWhenVisible>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <FadeInWhenVisible delay={0.1}>
            <Card className="border-none shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden bg-gradient-to-br from-purple-50 to-white dark:from-gray-900 dark:to-gray-800">
              <CardContent className="p-8">
                <div className="rounded-full bg-purple-100 dark:bg-purple-900/30 w-14 h-14 flex items-center justify-center mb-6">
                  <Brain className="h-7 w-7 text-purple-600 dark:text-purple-400" />
                </div>
                <h3 className="text-xl font-bold mb-3 dark:text-white">Advanced AI</h3>
                <p className="text-gray-600 dark:text-gray-300">
                  Access cutting-edge AI agents powered by the latest machine learning technologies
                </p>
              </CardContent>
            </Card>
          </FadeInWhenVisible>

          <FadeInWhenVisible delay={0.2}>
            <Card className="border-none shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden bg-gradient-to-br from-blue-50 to-white dark:from-gray-900 dark:to-gray-800">
              <CardContent className="p-8">
                <div className="rounded-full bg-blue-100 dark:bg-blue-900/30 w-14 h-14 flex items-center justify-center mb-6">
                  <Code className="h-7 w-7 text-blue-600 dark:text-blue-400" />
                </div>
                <h3 className="text-xl font-bold mb-3 dark:text-white">Easy Integration</h3>
                <p className="text-gray-600 dark:text-gray-300">
                  Seamlessly integrate agents into your existing workflows and applications
                </p>
              </CardContent>
            </Card>
          </FadeInWhenVisible>

          <FadeInWhenVisible delay={0.3}>
            <Card className="border-none shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden bg-gradient-to-br from-green-50 to-white dark:from-gray-900 dark:to-gray-800">
              <CardContent className="p-8">
                <div className="rounded-full bg-green-100 dark:bg-green-900/30 w-14 h-14 flex items-center justify-center mb-6">
                  <Shield className="h-7 w-7 text-green-600 dark:text-green-400" />
                </div>
                <h3 className="text-xl font-bold mb-3 dark:text-white">Secure & Private</h3>
                <p className="text-gray-600 dark:text-gray-300">
                  All agents undergo rigorous security checks and respect your data privacy
                </p>
              </CardContent>
            </Card>
          </FadeInWhenVisible>

          <FadeInWhenVisible delay={0.4}>
            <Card className="border-none shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden bg-gradient-to-br from-amber-50 to-white dark:from-gray-900 dark:to-gray-800">
              <CardContent className="p-8">
                <div className="rounded-full bg-amber-100 dark:bg-amber-900/30 w-14 h-14 flex items-center justify-center mb-6">
                  <Zap className="h-7 w-7 text-amber-600 dark:text-amber-400" />
                </div>
                <h3 className="text-xl font-bold mb-3 dark:text-white">Boost Productivity</h3>
                <p className="text-gray-600 dark:text-gray-300">
                  Automate tasks and enhance your workflow with specialized AI agents
                </p>
              </CardContent>
            </Card>
          </FadeInWhenVisible>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
